<template>
  <div>
    <buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
    
    <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
      <li style="width: 100%; margin-top:0px">
        <wTable id="xpane-0" :data="dataSet" :loading="loading"
                queryData="SalInvoiceLineViewInfo"
                :filter_language="['BalanceMode_Name','Invoice_Status','红字','virtual_flag']"
                :filter_thousandth="['Customer_Remain_Amount','数量','本币不含税单价','本币不含税金额','本币税额','本币价税合计','原币不含税单价','原币不含税金额']"
                :filter_date="['Invoice_Date','Payment_Date','Audit_Date']"
                :header="tableHeader"  :option="tableOption"  @lct="lct"
                ref="singleTable"></wTable>
      </li>
    </ul>
		<!-- <el-row> -->
    <el-row class="page">
      <el-col :span="18">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" :pager-count="5"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-col>
      <el-col :span="6">
        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
      </el-col>
    </el-row>
    <serce :isVisible="isVisible" queryData="SalInvoiceLineViewInfo" ref="ser" @getser="serclick"></serce>
    <ctable :isVisible="false" :title="$t('getapi[3866]')" queryData="SalInvoiceLineViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
  </div>
</template>

<script>
  import Common from '@/components/Common';
  import Array from '@/components/Array';
  export default {
    name: '3_saleinvoicedetailview',
      computed: {
          tableOption() {
              return {
                  border: true,
                  height: this.$windowSize.tableHeight3,
                  maxHeight: this.$windowSize.tableHeight3,
              }
          },
          tableHeight(){
              return this.$windowSize.tableHeight3
          }
      },
    data() {
      return {
        dataSet: [], // 主表数据
        isVisible: false, // 查询列表是否显示
        queryData: [], // 查询数组
        userData: [], // 用户信息
        DbTbNames: '',
        pageIndex: 1, // 当前页
        pageSize: this.$http.getPageSize('SalInvoiceLineViewInfo'), // 当前页数据量
        SelectIndexs: 1, //当前页面
        total: 0, // 数据总量
        loading: false, // 主表加载状态
        tableHeader: [],
          scrollTop:0,
      };
    },
      watch: {
          dataSet: function () {
              let that = this
              that.$nextTick(function () {
                  that.$processdata.initForm(0)
              })
          },
      },
    mounted: function () {
      let that = this;
      that.userData = sessionStorage.getItem('userData');
      that.PlanTypeArray = Array.methods.getPlanType();
      that.authority();
      that.colsort();
    },
      activated () {
          let that = this
          setTimeout(() => {
              that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                  that.scrollTop = res.target.scrollTop
              },false)
          }, 5000);
          // 路由跳转回来滚动到离开时的位置
          this.$nextTick(()=> {
              setTimeout(() => {
                  this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
              }, 13)
          })
      },
    methods: {
      colsort(){
        let that = this;
        that.$loadviewfields.Fileds('SalInvoiceLineViewInfo',0,PFileds=>{
        that.tableHeader=PFileds;		
        console.log("字段:"+JSON.stringify(PFileds));
      });	
      },
      sortclick(val){
        if(val==1){
          this.colsort();
        }
      },
      // 修改表格顺序
      opentable(){
        this.$refs.ctab.clearInputs(true);
      },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3866]"),this.$t("getapi[3846]"));
        },
      authority() {
        let that = this;
          if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
              that.$refs.SetBtn.SetOneBtnEnable('help',true);
          }
         that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
        //只读权
        if (that.$limits.ReadOnlyRightsView('plv2', 65, 1, that.total)) {
          if (that.total > 0) {
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
          } else {
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
          }
        }
        //操作权限-查询级别
        var limits = that.$limits.OperationAuthorityView('plv2', 65, 1, that.total);
        // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
        switch (limits) {
          case -1:
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
            break;
          case 1:
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            break;
          case -2:
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
            break;
          case 2:
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            break;
          case -3:
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
            break;
          case 3:
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            break;
          default:
            break;
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.$http.savePageSize('SalInvoiceLineViewInfo',val);
        this.getView();
        this.authority();
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getView();
        this.authority();
      },
      // 查询
      search() {
        let that = this;
        that.isVisible = true;
        that.$refs.ser.clearInput(that.isVisible, 'SalInvoiceLineViewInfo');
      },
      //获取查询条件
      serclick(val) {
        this.queryData = val;
        this.confirmGetView();
      },
      // 确认获取数据
      confirmGetView() {
        let that = this;
        that.pageIndex = 1
        that.isVisible = false;
        that.getView();
      },
      // 数据一览
      getView() {
        let that = this;
        that.loading = true;
        let datac = [];
        for (let i = 0; i < that.queryData.length; i++) {
          datac.push({
            query_Condition: that.queryData[i].query_Condition,
            query_field_type: that.queryData[i].Query_Field_Type,
            query_field_name: that.queryData[i].Query_Field_Name,
            query_sort: that.queryData[i].query_sort,
            row_sign: that.queryData[i].row_sign
          });
        }
        let token = JSON.parse(that.userData).token;
        let data = {
          PageIndex: that.pageIndex,
          PageSize: that.pageSize,
          SelectIndex: that.SelectIndexs,
          Param: datac
        };
        that.$http.urlpost('/Finance/FrmSaleInvoice/DLists', data, function (res) {
          if (res.Success == 1) {
            that.dataSet = res.DataContent;
            that.total = res.Totals;
            that.loading = false;
            that.DbTbNames = res.DbTbNames;
            that.authority();
          } else {
            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
          }
        });
      },
      // 刷新
      reflash() {
        let that = this;
        that.getView();
      },
      // 导出
      exps() {
          /*let that = this;
          let datac = [];
          for (let i = 0; i < that.queryData.length; i++) {
            datac.push({
              query_Condition: that.queryData[i].query_Condition,
              query_field_type: that.queryData[i].Query_Field_Type,
              query_field_name: that.queryData[i].Query_Field_Name,
              query_sort: that.queryData[i].query_sort,
              row_sign: that.queryData[i].row_sign
            });
          }
          let parm = {
            PageIndex: that.PageIndex,
            PageSize: that.PageSize,
            SelectIndex: that.SelectIndex,
            Ids: '',
            Param: datac
          };
          that.$refs.SetBtn.SetOneBtnEnable('exps', false);
          that.$http.urlpost('/Finance/FrmSaleInvoice/DLists/ExportToExecl', parm, function (res) {
            that.$refs.SetBtn.SetOneBtnEnable('exps', true);
            if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
            }
          });*/
          let that = this;
          let datac = [];
          for (let i = 0; i < that.queryData.length; i++) {
              datac.push({
                  query_Condition: that.queryData[i].query_Condition,
                  query_field_type: that.queryData[i].Query_Field_Type,
                  query_field_name: that.queryData[i].Query_Field_Name,
                  query_sort: that.queryData[i].query_sort,
                  row_sign: that.queryData[i].row_sign
              });
          }
          let parm = {
              query_sign: "SalInvoiceLineViewInfo",
              fromname: that.$t('getapi[3866]'),
              SelectIndex: 0,
              MultyVer: that.$processdata.getLanguage(),
              Param: datac
          };
          that.$processdata.commonExport(parm)
      },
    }
  };
</script>

<style scoped lang="less">
  table {
    border-collapse: separate;
    border-spacing: 0px 5px;

    td {
      padding-left: 3px;
      white-space: pre;
    }
  }
</style>